import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CDrawingCanvasComponent } from './c-drawing-canvas.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  imports: [
    CommonModule,
    IonicModule
  ],
  declarations: [CDrawingCanvasComponent],
  exports: [CDrawingCanvasComponent]
})
export class CDrawingCanvasModule { }
